import Splide from '@splidejs/splide';

document.querySelectorAll('.js-photo-slider').forEach((carousel) => {
  const slider = new Splide(carousel, {
    type: 'scroll',
    arrows: true,
    pagination: true,
    gap: 20,
    autoWidth: true,
    breakpoints: {
      767: {

      },
    },
  });

  slider.mount();
});
